import './Axis.css';
export var axis = '_90oaxp0-3-15-1';